module.exports = __webpack_public_path__ + "img/post_button.ba3def92.png";